import type { NodesFactory } from '@commons/pagebuilder/nodes';

import AiiAMemberNode from './Member';

/**
 * Enum of all available node bundles for AiiA.
 */

export enum AIIA_NODE_BUNDLE {
  Member = 'member',
}

/**
 * Factory of all available nodes for AiiA.
 */

export const aiiaNodes: NodesFactory = {
  [AIIA_NODE_BUNDLE.Member]: AiiAMemberNode,
};
